import { render, staticRenderFns } from "./AppBox.vue?vue&type=template&id=036cba53&scoped=true"
import script from "./AppBox.vue?vue&type=script&lang=js"
export * from "./AppBox.vue?vue&type=script&lang=js"
import style0 from "./AppBox.vue?vue&type=style&index=0&id=036cba53&prod&scoped=true&lang=css"
import style1 from "./AppBox.vue?vue&type=style&index=1&id=036cba53&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036cba53",
  null
  
)

export default component.exports